import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  //const API_BASE_URL = 'http://localhost:5000/api/';
  const API_BASE_URL = '/api/';
  //const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/';

  // Function to validate token with the server
  const validateToken = async () => {
    if (!token) {
      setIsValid(false);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}auth/validate`, {
        method: 'GET',
        headers: { Authorization: token },
      });

      if (response.ok) {
        setIsValid(true);
      } else {
        // Token is invalid or expired
        setIsValid(false);
        localStorage.removeItem('token');
        setToken(null);
      }
    } catch (error) {
      console.error('Token validation error:', error);
      setIsValid(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Validate token on initial load and when token changes
  useEffect(() => {
    validateToken();
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setIsValid(false);
  };

  const isAuthenticated = () => !!token && isValid;

  return (
    <AuthContext.Provider value={{
      token,
      login,
      logout,
      isAuthenticated,
      isValid,
      isLoading,
      validateToken,
      API_BASE_URL
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
